module.exports = __webpack_public_path__ + "static/media/spinner.6192e41a.gif";